import { useEffect, useState } from "react";
import api from "../../lib/api";
import { ScrollText } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export default function Logs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-serif text-3xl sm:text-4xl text-white mb-1">Garson Aktivite Logları</h1>
      <p className="text-zinc-400 text-sm mb-6">Garsonların sipariş ve stok işlemleri kayıt altında</p>

      <div className="card-lux overflow-hidden">
        {logs.length === 0 && <p className="text-zinc-600 text-sm text-center py-12">Henüz kayıt yok</p>}
        <div className="divide-y divide-[#D4AF37]/10">
          {logs.map((l) => (
            <div key={l.id} className="flex items-start gap-4 px-5 py-4" data-testid={`log-${l.id}`}>
              <div className="h-9 w-9 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center shrink-0"><ScrollText size={16} className="text-[#D4AF37]" /></div>
              <div className="flex-1 min-w-0">
                <div className="text-sm text-white"><span className="text-[#FFE599]">{l.userName}</span> — {l.detail}</div>
                <div className="text-xs text-zinc-500 font-mono mt-1">{fmt(l.createdAt)} • {l.action}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
